import { Panel, PanelBorderRadius, PanelBorderStyle, PanelTheme } from '@apply/components';

export const PropertyInArizonaWarning = () => {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', paddingTop: '1rem' }}>
            <Panel
                theme={PanelTheme.Red}
                borderRadius={PanelBorderRadius.Small}
                borderStyle={PanelBorderStyle.None}
                width={'100%'}
            >
                For property in Arizona, the appraisal cost and underwriting fee
                <br />
                should <b>NOT</b> be paid now; they should be at closing of the loan.
            </Panel>
        </div>
    );
};
